<span
  [innerHTML]="svg$ | async"
  [ngClass]="class"
  class="inline-flex items-center justify-center"
></span>
